export { default } from './IntakeSegmentPreview';
